import React, { useEffect } from "react";

// ESRI Components
import * as projection from "@arcgis/core/geometry/projection";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";

import { renderDecimalMinuteSeconds } from "../../Shared/Functions";
import type MapView from "@arcgis/core/views/MapView";

interface Props {
  latlon: string;
  view: MapView;
  sidebarVisibility: boolean;
}

var scaleHandler,
  coordinateHandler = null;

export default function CoordinateWidget({
  latlon,
  view,
  sidebarVisibility,
}: Props) {
  // useState
  const [scale, setScale] = React.useState(204800);
  const [outSpatialReference] = React.useState(
    new SpatialReference({
      wkid: 4326,
    })
  );
  const [renderWidget, setRenderWidget] = React.useState(true);
  const [coordinate, setCoordinate] = React.useState({
    latitude: 40.8098,
    longitude: -91.0993,
  });

  useEffect(() => {
    // if no pointer then do not render widget
    if (!window.matchMedia("(pointer:fine)").matches) {
      setRenderWidget(false);
    }
  }, []);

  // Update the localforage store when the render type changes
  useEffect(() => {
    if (renderWidget) {
      initializeHandlers();
    }
  }, [latlon]);

  const initializeHandlers = () => {
    // Remove handlers
    if (scaleHandler) scaleHandler.remove();
    if (coordinateHandler) coordinateHandler.remove();

    // load the projection module and then hook up event handlers
    projection.load().then(() => {
      scaleHandler = view.watch("scale", (value) => {
        if (value % 1 === 0) {
          setScale(value);
        }
      });

      coordinateHandler = view.on("pointer-move", (event) => {
        var point = view.toMap({ x: event.x, y: event.y });
        var mp = projection.project([point], outSpatialReference);
        if (latlon) {
          setCoordinate({
            latitude: renderDecimalMinuteSeconds(mp[0].latitude),
            longitude: renderDecimalMinuteSeconds(mp[0].longitude),
          });
        } else {
          setCoordinate({
            latitude: mp[0].latitude.toFixed(4),
            longitude: mp[0].longitude.toFixed(4),
          });
        }
      });
    });
  };

  // Return nothing if the renderWidget is set to false
  if (renderWidget === false) {
    return null;
  }

  return (
    <div
      className="bottom-right map-buttons"
      style={sidebarVisibility ? { right: "365px" } : null}
    >
      <div
        className="map_container text-right"
        style={{ position: "absolute", top: "-40px", right: "0px" }}
      >
        Scale: 1:{scale}
      </div>
      <div className="map_container">
        {`${coordinate.longitude}, ${coordinate.latitude}`}
      </div>
    </div>
  );
}
